export function getPlain<T = any>(state: State | T): T {
  if (!state) return state
  return 'toJS' in state ? state.toJS() : state
}
